import { render, staticRenderFns } from "./VRow.vue?vue&type=template&id=452d37ee&scoped=true&"
import script from "./VRow.vue?vue&type=script&lang=js&"
export * from "./VRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452d37ee",
  null
  
)

component.options.__file = "VRow.vue"
export default component.exports